<!-- eslint-disable max-len -->
<template>
  <footer class="fixed shadow-lg bg-neutral-800 w-full z-50 flex flex-row items-center h-10 justify-between">
    <div class="flex flex-row w-full h-full items-center justify-between px-8">
      <p class="font-primary text-xs lg:text-sm font-semibold text-neutral-100 text-center">
        &copy;{{ currentYear }} | Ako Ang Bukas | v.1.0.0
      </p>
      <a href="https://docs.google.com/document/d/1s6uR-Lzp_HxgI9LCZU4F_gbJtnSMFMOBBwJ3iqJpfY0/edit?usp=sharing"
        target="_blank" class="font-primary text-xs lg:text-sm font-semibold text-neutral-100">
        Privacy Policy
      </a>
    </div>
  </footer>
</template>
<script>
// import PrimaryButton from './PrimaryButton.vue';
// import { getAuth, signOut } from 'firebase/auth';
// import { mapGetters } from 'vuex';

export default {
  name: 'FooterComponent',
  components: {
    // PrimaryButton,
  },
  methods: {
    logout() {
      // const auth = getAuth();
      // signOut(auth)
      //   .then(() => {
      //     // Sign-out successful.
      // this.$store.commit('setUser', {});
      // this.$router.push('/');
      // })
      // .catch((error) => {
      //   // An error happened.
      //   console.log(error);
      // });
    },
    // logout() {
    //   console.log('logout!');
    // },
    bar() {
      console.log('keydown');
    },
  },
  computed: {
    currentYear() {
      const date = new Date();
      return date.getFullYear();
    },
  },
};
</script>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}
</style>
